import en from './translations/en.json'
import vi from './translations/vi.json'
import hi from './translations/hi.json'

const messages = { en, vi, hi }

export default messages
